import type { BoxesContent } from "@loot-os/design-system/templates/boxes/boxesContent";
import { useBoxCategoriesContent } from "./content/categories.js";
import { useBoxFiltersContent } from "./content/filters.js";
import { useBoxGridContent } from "./content/grid.js";
import { useBoxesBreadcrumbContent, useBoxesTitleContent } from "./content/heading.js";
import { useBoxTabsContent } from "./content/tabs.js";
import { useTopHitsContent } from "./content/topHits.js";

/** Every boxes-page section's content, the same under every template. */
export function useBoxesContent(): BoxesContent {
  return {
    breadcrumb: useBoxesBreadcrumbContent(),
    title: useBoxesTitleContent(),
    tabs: useBoxTabsContent(),
    categories: useBoxCategoriesContent(),
    filters: useBoxFiltersContent(),
    topHits: useTopHitsContent(),
    grid: useBoxGridContent(),
  };
}
